import { Grid, Link, Typography } from '@material-ui/core';
import React from 'react';
import Logo from '../../common/components/Logo';

const AppDownload = () => {
  return (
    <Grid container direction='column' alignItems='center' spacing={4}>
      <Grid item>
        <Logo />
      </Grid>
      <Grid container item direction='column' alignItems='center'>
        <Typography variant='h6'>
          Download our app to view this content.
        </Typography>
        <Link href='https://play.google.com/store/apps/details?id=com.sloaninteractiveexperience.app'>
          <img src='/assets/Google_Play.png' alt='Get it on Google Play' />
        </Link>
        <Link href='https://apps.apple.com/us/app/sloan-longway/id1633719832'>
          <img src='/assets/App_Store.png' alt='Available on the App Store' />
        </Link>
      </Grid>
    </Grid>
  );
};

export default AppDownload;
